module.exports = __webpack_public_path__ + "34736292/img/arrow-share-icon.00a12c29.svg";